import type { FC } from 'react';
import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import usePrevious from 'react-use/lib/usePrevious';

import type { TCountdownTimer } from './models';

export const CountdownTimer: FC<TCountdownTimer> = props => {
    const {
        calculateSeconds,
        date,
        format = 'mm:ss',
        onStart,
        onStop,
        secondsToTime,
        time = '05:00',
        todayOnly = true,
    } = props;

    if (process.env.NODE_ENV === 'development' && props.time && date) {
        console.error('Используйте что-то одно: time или date');
    }

    const interval = useRef<number>();

    const finishDate = useMemo(() => {
        if (date) return new Date(date);

        const [minutes, seconds] = time.split(':').map(v => parseInt(v, 10));
        const remainingMs = (minutes * 60 + seconds) * 1000;

        return new Date(Date.now() + remainingMs);
    }, [date, time, todayOnly]);

    const [seconds, setSeconds] = useState(calculateSeconds(finishDate, todayOnly));
    const prevSeconds = usePrevious(seconds);

    const updateSeconds = useCallback(() => {
        setSeconds(calculateSeconds(finishDate, todayOnly));
    }, [finishDate, calculateSeconds, todayOnly]);

    useEffect(() => {
        onStart?.();
    }, []);

    useEffect(() => {
        if (prevSeconds && prevSeconds > 0 && seconds === 0) {
            onStop?.();
            clearInterval(interval.current);
        }
    }, [seconds, prevSeconds, onStop]);

    useEffect(() => {
        updateSeconds();

        interval.current = window.setInterval(updateSeconds, 1000);

        return () => {
            clearInterval(interval.current);
        };
    }, [updateSeconds]);

    return <>{secondsToTime(String(Math.round(seconds)), format)}</>;
};
